import { useState, useEffect } from 'react'

/**
 * Debounce a value by the specified delay.
 * Returns the debounced value that updates only after the delay has passed
 * without the input value changing.
 */
export function useDebounce<T>(value: T, delay: number): T {
    const [debouncedValue, setDebouncedValue] = useState<T>(value)

    useEffect(() => {
        const timer = setTimeout(() => {
            setDebouncedValue(value)
        }, delay)

        return () => {
            clearTimeout(timer)
        }
    }, [value, delay])

    return debouncedValue
}
